<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <div v-if="pageLoaded">
      <span v-show="false">{{ reactivity }}</span>
      <!-- loading component -->
      <Loading />
      <b-alert
        v-model="showTop"
        class="position-fixed fixed-top m-0 mt-9 rounded-0 bg-purple text-white text-center border-03"
        style="z-index: 2000; opacity: 60%"
        dir="rtl"
      >
        پیشنویس ثبت شد!
      </b-alert>
      <b-card
        v-if="
          $router.currentRoute.path.indexOf(
            '/researcher/completeArticle/' + this.$route.params.id
          ) == 0
        "
        style="border: 0"
        class="mt-0 mb-0"
      >
        <b-card
          v-if="
            (proposal.status == 'نیاز به تکمیل / اصلاح' ||
              proposal.status == 'پیش نویس') &&
            proposal.adminMessage
          "
          header-bg-variant="danger"
          header-text-variant="white"
          header="اصلاحات مورد نیاز"
          style="border: 0"
          class="shadow p-3 mb-5 bg-white rounded mt-0"
          >{{ errorMessage }}</b-card
        >
        <b-tabs class="mb-3" pills vertical v-model="tabIndex">
          <div class="d-flex justify-content-center mt-3">
            <!-- NOTE (b-previousTab) to go to the previous tab -->
            <b-button
              v-if="tabIndex != 0"
              class="mx-1"
              variant="light"
              @click="changePage('back')"
              >مرحله قبل</b-button
            >
            <!-- NOTE (b-saveDraft) to save draft -->
            <b-button
              :disabled="isSaving"
              class="mx-1"
              variant="success"
              @click="saveDraft()"
              >ثبت پیشنویس</b-button
            >
            <!-- NOTE (b-nextTab) to go to the next tab -->
            <b-button
              v-if="tabIndex != 7"
              class="mx-1"
              variant="primary"
              @click="changePage('next')"
              >مرحله بعد</b-button
            >
          </div>
          <div class="d-flex justify-content-center mt-3"></div>
          <b-tab :title="'سنجش شناسه مقاله'" active>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">سنجش شناسه مقاله</h4>
              </template>
              <b-form-group>
                <div class="d-flex" dir="ltr">
                  <label
                    for="switch_1"
                    :class="
                      proposal.initialObligation
                        ? 'ml-3 mb-0 done'
                        : 'ml-3 mb-0 required'
                    "
                  >
                    اینجانب تعهد می کنم با مطالعه و آگاهی از
                    <b-button
                      id="downLoad"
                      title="دانلود تعهدات"
                      variant="link"
                      href="/researcher/rules/article/شیوه نامه مقالات.pdf"
                    >
                      <b-tooltip
                        placement="bottomleft"
                        target="downLoad"
                        triggers="hover"
                        variant="info"
                        >دانلود شیوه‌نامه</b-tooltip
                      >شیوه‌نامه حمایت از مقالات ستاد توسعه زیست فناوری </b-button
                    >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست در
                    سامانه اقدام می نمایم
                  </label>
                  <b-form-checkbox
                    id="switch_1"
                    v-model="proposal.initialObligation"
                  ></b-form-checkbox>
                </div>
              </b-form-group>
              <hr />
              <h3 class="text-primary mb-4">پژوهشگر گرامی</h3>

              <p>
                به ابزار حمایت از مقالات سامانه تقسیم کار ملی خوش آمدید.
                خواهشندیم ابتدا به سوالات زیر پاسخ دهید:
              </p>

              <h6 class="done text-center mb-3">شناسه دیجیتال مجله</h6>
              <div dir="ltr" class="mb-3 text-left readonly-box">
                {{ proposal.doi }}
              </div>
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات اصلی مقاله(' + step1progress + '%)'" active>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات اصلی مقاله</h4>
              </template>
              <b-form-group
                label="عنوان به زبان فارسی (حداکثر 20 کلمه)"
                :class="proposal.faSubject ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.faSubject"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="عنوان به زبان انگلیسی"
                :class="proposal.enSubject ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  dir="ltr"
                  v-model="proposal.enSubject"
                  @keydown="nameKeydown($event)"
                ></b-form-input>
              </b-form-group>
            </b-card>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">وابستگی مقاله</h4>
              </template>
              <b-row class="mb-2">
                <b-col>
                  <span
                    :class="
                      proposal.universityId
                        ? proposal.universityId != 1
                          ? 'done'
                          : proposal.otherUniversity
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                  >
                    دانشگاه محل اجرای مقاله</span
                  >
                </b-col>
                <b-col class="text-left">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="proposal.universityId"
                    name="checkbox-1"
                    :value="notUniversity"
                    unchecked-value=""
                    @change="
                      reactivity = !reactivity;
                      proposal.mehvarId = '';
                    "
                  >
                    سایر دانشگاه ها
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-group>
                <Select2
                  v-model="proposal.universityId"
                  :options="universities"
                  :settings="{ width: '100%' }"
                  @change="removeMehvar()"
                  :disabled="proposal.universityId == notUniversity"
                ></Select2>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherUniversity"
                  v-show="proposal.universityId == notUniversity"
                  placeholder="نام دانشگاه مورد نظر"
                  @input="reactivity = !reactivity"
                ></b-form-input>
              </b-form-group>
              <!--Tooltip usage full here https://bootstrap-vue.org/docs/directives/tooltip ::::::::::::: v-b-tooltip.hover.left title="متن توضیحی"-->
              <b-form-group
                :disabled="!proposal.universityId"
                label="محور مقاله (لطفا یک گزینه را انتخاب کنید)"
                :class="
                  proposal.mehvarId
                    ? proposal.mehvarId != notMehvar
                      ? 'done'
                      : proposal.otherMehvars
                      ? 'done'
                      : 'required'
                    : 'required'
                "
              >
                <b-list-group>
                  <b-list-group-item
                    style="cursor: pointer"
                    v-for="(mehvar, index) in computedMehvars"
                    :variant="selectedMehvar == index ? 'info' : 'light'"
                    :key="index"
                    @click="
                      proposal.mehvarId = mehvar.id;
                      selectedMehvar = index;
                    "
                    :disabled="mehvar.id == 0"
                  >
                    <span v-if="selectedMehvar == index">
                      <i class="fa fa-check-circle text-success"></i>
                    </span>
                    <span v-else>
                      <i class="fa fa-circle"></i>
                    </span>
                    {{ mehvar.text }}
                  </b-list-group-item>
                </b-list-group>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherMehvars"
                  v-show="
                    proposal.mehvarId == notMehvar ||
                    proposal.universityId == notUniversity
                  "
                  placeholder="نام محور مورد نظر"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="ماهیت مقاله"
                :class="
                  proposal.typeStudy ||
                  proposal.typeSystemicDevelopmental ||
                  proposal.typePractical
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-checkbox
                  v-model="proposal.typeStudy"
                  class="c-dark mt-3"
                  >مطالعاتی</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="proposal.typeSystemicDevelopmental"
                  class="c-dark mt-3"
                  >سیستمی و توسعه‌ای</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="proposal.typePractical"
                  class="c-dark mt-3"
                  >کاربردی</b-form-checkbox
                >
              </b-form-group>

              <b-form-group
                label="حوزه مقاله"
                :class="
                  proposal.zoneMedicine ||
                  proposal.zoneAgriculture ||
                  proposal.zoneEnvironment ||
                  proposal.zoneIndustrial ||
                  proposal.zoneBioComputing ||
                  proposal.zoneOther
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-checkbox
                  v-model="proposal.zoneMedicine"
                  class="c-dark mt-3"
                  >پزشکی</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="proposal.zoneAgriculture"
                  class="c-dark mt-3"
                  >کشاورزی</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="proposal.zoneEnvironment"
                  class="c-dark mt-3"
                  >محیط زیست</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="proposal.zoneIndustrial"
                  class="c-dark mt-3"
                  >صنعتی</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="proposal.zoneBioComputing"
                  class="c-dark mt-3"
                  >رایانش زیستی</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="proposal.zoneOther"
                  class="c-dark mt-3"
                  >سایر</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات نویسنده مسئول مقاله(' + step2progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">نویسندگان</h4>
              </template>

              <!-- NOTE (t-personnelCost) to show personnel costs with details about each personnel -->
              <b-table
                responsive
                small
                show-empty
                bordered
                head-variant="light"
                :items="colleagues"
                :fields="writersField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(nameEn)="data">
                  <b-form-input trim v-model="data.item.nameEn" />
                </template>
                <template v-slot:cell(name)="data">
                  <b-form-input trim v-model="data.item.name" />
                </template>
                <template v-slot:cell(nationality)="data">
                  <b-form-input trim v-model="data.item.nationality" />
                </template>
                <template v-slot:cell(position)="data">
                  <b-form-input trim v-model="data.item.position" />
                </template>
                <!-- <template v-slot:cell(operation)="data">
                <div>
                  <b-button
                    variant="danger"
                    class="mr-2"
                    @click="addInfo(data.index)"
                  ></b-button>
                </div>
              </template> -->
              </b-table>
              <hr />
              <b-row>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2">
                  تذکر: در صورتی که نویسنده‌ی مسئول مقاله هستید تیک گزینه‌ی زیر
                  را بزنید در غیر این صورت رضایتنامه‌ی نویسنده‌ی مسئول مقاله را
                  بارگذاری کنید.
                </p>
              </b-row>

              <b-form-group>
                <div class="d-flex" dir="rtl">
                  <b-form-checkbox
                    v-model="proposal.responsibleAuthor"
                  ></b-form-checkbox>
                  <label class="ml-2"
                    ><h6>نویسنده‌ی مسئول مقاله هستم</h6></label
                  >
                </div>
              </b-form-group>
              <div v-if="!proposal.responsibleAuthor">
                <b-form-group label="رضایتنامه نویسنده مسئول:">
                  <b-form-file
                    :state="Boolean(proposal.consentResponsibleAuthorFile)"
                    :disabled="Boolean(proposal.consentResponsibleAuthorFile)"
                    @input="
                      uploadFile(
                        uploadedFiles[0].file,
                        0,
                        'consentResponsibleAuthorFile'
                      )
                    "
                    v-model="uploadedFiles[0].file"
                    browse-text="بارگذاری"
                    :placeholder="
                      files[0]
                        ? files[0].showName
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-row></b-row>
                    <br />
                    <b-progress
                      v-if="uploadedFiles[0].uploadPercentage"
                      :value="uploadedFiles[0].uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="uploadedFiles[0].striped"
                      :variant="uploadedFiles[0].variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="uploadedFiles[0].isUploaded"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row
                          align-h="end"
                          v-if="proposal.consentResponsibleAuthorFile"
                        >
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success"
                              :href="proposal.consentResponsibleAuthorFile"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="delFile(0, 'consentResponsibleAuthorFile')"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
              </div>
              <b-form-group
                :class="proposal.executorIBAN ? 'done' : 'required'"
                description
                label="شماره شبا:"
              >
                <b-form-input
                  trim
                  v-model="proposal.executorIBAN"
                  :no-wheel="true"
                  type="number"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                :class="proposal.executorBankName ? 'done' : 'required'"
                description
                label="نام بانک:"
              >
                <b-form-input
                  trim
                  v-model="proposal.executorBankName"
                  type="text"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                :class="proposal.executorBankAccountName ? 'done' : 'required'"
                description
                label="نام صاحب حساب:"
              >
                <b-form-input
                  trim
                  v-model="proposal.executorBankAccountName"
                  type="text"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                :class="proposal.executorTel ? 'done' : 'required'"
                description
                label="شماره تماس:"
              >
                <b-form-input
                  trim
                  v-model="proposal.executorTel"
                  :no-wheel="true"
                  type="number"
                ></b-form-input>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'مشخصات مقاله(' + step3progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">مشخصات</h4>
              </template>

              <b-form-group
                :class="proposal.enSubject ? 'done' : 'required'"
                label="عنوان به زبان انگلیسی"
                style="text-align: center"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.enSubject"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    :class="proposal.abstract ? 'done' : 'required'"
                    label="چکیده:"
                    style="text-align: center"
                  >
                    <b-form-textarea
                      trim
                      type="text"
                      rows="6"
                      v-model="proposal.abstract"
                      max-rows="6"
                    ></b-form-textarea> </b-form-group
                ></b-col>
                <b-col>
                  <b-form-group
                    label="کلید واژگان:"
                    style="text-align: center"
                    :class="proposal.keywords ? 'done' : 'required'"
                  >
                    <b-form-textarea
                      trim
                      type="text"
                      rows="6"
                      v-model="proposal.keywords"
                      max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>

              <h6 class="done text-center mb-3">شناسه دیجیتال مجله</h6>
              <div dir="ltr" class="mb-3 text-left readonly-box">
                {{ proposal.doi }}
              </div>
              <b-row class="mt-3">
                <b-col cols="12">
                  <b-form-group
                    :class="proposal.ISSN ? 'done' : 'required'"
                    label="ISSN مجله "
                    style="text-align: center"
                  >
                    <b-form-tags
                      v-model="proposal.ISSN"
                      trim
                      type="text"
                      separator=" "
                      placeholder=""
                      tag-pills
                      addButtonText="افزودن"
                      style="font-size: 13px !important"
                    ></b-form-tags> </b-form-group
                ></b-col>
              </b-row>

              <b-form-group
                label="ضریب تاثیر مجله"
                style="text-align: center"
                :class="proposal.impactFactor ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="number"
                  :no-wheel="true"
                  v-model="proposal.impactFactor"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="تشکرات:"
                :class="proposal.acknowledgment ? 'done' : 'required'"
                style="text-align: center"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.acknowledgment"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                :class="proposal.articlePdfFile ? 'done' : 'required'"
                label="فایل PDF مقاله"
              >
                <b-form-file
                  :state="Boolean(proposal.articlePdfFile)"
                  :disabled="Boolean(proposal.articlePdfFile)"
                  @input="
                    uploadFile(uploadedFiles[1].file, 1, 'articlePdfFile')
                  "
                  v-model="uploadedFiles[1].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[1]
                      ? files[1].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                  accept=".pdf"
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <br />
                  <b-progress
                    v-if="uploadedFiles[1].uploadPercentage"
                    :value="uploadedFiles[1].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[1].striped"
                    :variant="uploadedFiles[1].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[1].isUploaded"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.articlePdfFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success"
                            :href="proposal.articlePdfFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(1, 'articlePdfFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'زمانبندی(' + step4progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">زمانبندی</h4>
              </template>
              <b-form-group
                label="تاریخ چاپ:"
                style="text-align: right"
                label-cols="2"
                label-size="lg"
              >
                <b-row>
                  <b-col cols="5" style="text-align: center"
                    >شمسی
                    <b-col>
                      <b-form-input
                        trim
                        disabled
                        v-model="proposal.articlePublicationDate"
                      ></b-form-input>
                    </b-col>
                  </b-col>
                  <b-col cols="5" style="text-align: center"
                    ><div class="mb-3">میلادی</div>
                    <datePicker
                      color="#7b1fa2"
                      locale="en"
                      format="jYYYY/jMM/jDD"
                      display-format="YYYY/MM/DD"
                      v-model="proposal.articlePublicationDate"
                    ></datePicker>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group
                label="تاریخ ثبت:"
                style="text-align: right"
                label-cols="2"
                label-size="lg"
              >
                <b-row>
                  <b-col cols="5" style="text-align: center"
                    >شمسی
                    <b-col>
                      <b-form-input
                        trim
                        disabled
                        v-model="proposal.articleSubmissionDate"
                      ></b-form-input>
                    </b-col>
                  </b-col>
                  <b-col cols="5" style="text-align: center"
                    ><div class="mb-3">میلادی</div>
                    <datePicker
                      color="#7b1fa2"
                      locale="en"
                      format="jYYYY/jMM/jDD"
                      display-format="YYYY/MM/DD"
                      v-model="proposal.articleSubmissionDate"
                    ></datePicker>
                  </b-col>
                </b-row>
              </b-form-group>
              <hr />
              <b-form-group
                label="تاریخ بازبینی:"
                style="text-align: right"
                label-cols="2"
                label-size="lg"
              >
                <b-row>
                  <b-col cols="5" style="text-align: center"
                    >شمسی
                    <b-col>
                      <b-form-input
                        trim
                        disabled
                        v-model="proposal.articleRevisionDate"
                      ></b-form-input>
                    </b-col>
                  </b-col>
                  <b-col cols="5" style="text-align: center"
                    ><div class="mb-3">میلادی</div>
                    <datePicker
                      color="#7b1fa2"
                      locale="en"
                      format="jYYYY/jMM/jDD"
                      v-model="proposal.articleRevisionDate"
                      display-format="YYYY/MM/DD"
                    ></datePicker>
                  </b-col>
                </b-row>
              </b-form-group>
              <hr />
              <b-form-group
                label="تاریخ پذیرش:"
                style="text-align: right"
                label-cols="2"
                label-size="lg"
              >
                <b-row>
                  <b-col cols="5" style="text-align: center"
                    >شمسی
                    <b-col>
                      <b-form-input
                        trim
                        disabled
                        v-model="proposal.articleAcceptanceDate"
                      ></b-form-input>
                    </b-col>
                  </b-col>
                  <b-col cols="5" style="text-align: center"
                    ><div class="mb-3">میلادی</div>
                    <datePicker
                      color="#7b1fa2"
                      locale="en"
                      format="jYYYY/jMM/jDD"
                      display-format="YYYY/MM/DD"
                      v-model="proposal.articleAcceptanceDate"
                    ></datePicker>
                  </b-col>
                </b-row>
              </b-form-group>
              <hr />
              <b-form-group
                label="تاریخ انتشار:"
                style="text-align: right"
                label-cols="2"
                label-size="lg"
              >
                <b-row>
                  <b-col cols="5" style="text-align: center"
                    >شمسی
                    <b-col>
                      <b-form-input
                        trim
                        disabled
                        v-model="proposal.articleReleaseDate"
                      ></b-form-input>
                    </b-col>
                  </b-col>
                  <b-col cols="5" style="text-align: center"
                    ><div class="mb-3">میلادی</div>
                    <datePicker
                      color="#7b1fa2"
                      locale="en"
                      format="jYYYY/jMM/jDD"
                      display-format="YYYY/MM/DD"
                      v-model="proposal.articleReleaseDate"
                    ></datePicker>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'وجه تشویقی(' + step5progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">میزان وجه تشویقی</h4>
              </template>
              <b-col cols="6">
                <b-form-group label="مبلغ:">
                  <div
                    v-if="
                      0 < proposal.impactFactor && proposal.impactFactor < 4
                    "
                  >
                    <h3 class="text-success">2,000,000 تومان</h3>
                  </div>
                  <div
                    v-else-if="
                      4 <= proposal.impactFactor && proposal.impactFactor <= 8
                    "
                  >
                    <h3 class="text-success">3,000,000 تومان</h3>
                  </div>
                  <div v-else-if="proposal.impactFactor > 8">
                    <h3 class="text-success">4,000,000 تومان</h3>
                  </div>
                  <div v-else>
                    <h4 class="text-danger">
                      لطفا جهت تعیین میزان وجه تشویقی، از بخش مشخصات مقاله ضریب
                      تاثیر مجله را انتخاب کنید.
                    </h4>
                  </div>
                </b-form-group>
              </b-col>
            </b-card>
          </b-tab>
          <b-tab :title="'تعهدات(' + step6progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">تعهدات</h4>
              </template>
              <b-form-checkbox
                :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[0]"
                >این مقاله در بخش حمایت از رساله های دکتری و یا در بخش حمایت از
                پایان نامه های ارشد زیست فناوری مورد حمایت قرار نگرفته
                است.</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[1]"
                >ملاک IF بر اساس JCR سال 2018 مورد تایید خواهد
                بود.</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[2]"
                >میزان ضریب تاثیر (IF) مقاله تعیین کننده میزان حمایت تشویقی
                خواهد بود</b-form-checkbox
              >
              <b-form-checkbox
                :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[3]"
                >ثبت در خواست هیچگونه حقی برای پذیرش مقاله ایجاد نمی
                کند.</b-form-checkbox
              >
            </b-card>
          </b-tab>
          <b-tab :title="'مرور نهایی و ارسال(' + lastStepProgress + '%)'">
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-1 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات مقاله&nbsp;({{ step1progress }}%)
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 1"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul class="p-2">
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b>عنوان به زبان فارسی:</b> {{ proposal.faSubject }}
                      </li>
                      <li :class="proposal.enSubject ? 'done' : 'required'">
                        <b>عنوان به زبان انگلیسی:</b> {{ proposal.enSubject }}
                      </li>

                      <li :class="proposal.universityId ? 'done' : 'required'">
                        <b>دانشگاه محل اجرای مقاله: </b>
                        {{
                          proposal.universityId
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.universityId == notUniversity"
                        :class="proposal.otherUniversity ? 'done' : 'required'"
                      >
                        <b>نام دانشگاه:</b> {{ proposal.otherUniversity }}
                      </li>
                      <li
                        v-if="proposal.mehvarId != notMehvar && mehvars.length"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور مقاله:</b>
                        {{
                          proposal.mehvarId
                            ? mehvars.filter(
                                (x) => x.id == proposal.mehvarId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور مقاله:</b> سایر محورها
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.otherMehvars ? 'done' : 'required'"
                      >
                        <b>نام محور:</b> {{ proposal.otherMehvars }}
                      </li>
                      <li
                        :class="
                          proposal.typeStudy ||
                          proposal.typeSystemicDevelopmental ||
                          proposal.typePractical
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>ماهیت مقاله:</b>
                        <b-form-group disabled>
                          <b-form-checkbox v-model="proposal.typeStudy"
                            >مطالعاتی</b-form-checkbox
                          >
                          <b-form-checkbox
                            v-model="proposal.typeSystemicDevelopmental"
                            >سیستمی و توسعه‌ای</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.typePractical"
                            >کاربردی</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                      <li
                        :class="
                          proposal.zoneMedicine ||
                          proposal.zoneAgriculture ||
                          proposal.zoneEnvironment ||
                          proposal.zoneIndustrial ||
                          proposal.zoneBioComputing ||
                          proposal.zoneOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>حوزه مقاله:</b>
                        <b-form-group label="" disabled>
                          <b-form-checkbox v-model="proposal.zoneMedicine"
                            >پزشکی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneAgriculture"
                            >کشاورزی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneEnvironment"
                            >محیط زیست</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneIndustrial"
                            >صنعتی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneBioComputing"
                            >رایانش زیستی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneOther"
                            >سایر</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-2 variant="light">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات نویسنده&nbsp;({{ step2progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 2"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <!-- NOTE (t-personnelCost) to show personnel costs with details about each personnel -->
                    <b-table
                      responsive
                      small
                      show-empty
                      bordered
                      head-variant="light"
                      :items="colleagues"
                      :fields="writersField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <b-form-group disabled>
                      <div class="d-flex mt-4" dir="rtl">
                        <b-form-checkbox
                          v-model="proposal.responsibleAuthor"
                        ></b-form-checkbox>
                        <label class="ml-2"
                          ><h6>نویسنده‌ی مسئول مقاله هستم</h6></label
                        >
                      </div>
                    </b-form-group>
                    <li
                      v-if="!proposal.responsibleAuthor"
                      :class="
                        proposal.consentResponsibleAuthorFile
                          ? 'done'
                          : 'required'
                      "
                    >
                      <b>رضایتنامه نویسنده مسئول: </b>
                      <a
                        v-if="proposal.consentResponsibleAuthorFile"
                        :href="proposal.consentResponsibleAuthorFile"
                        target="blank"
                        >{{ files[0].showName }}</a
                      >
                      <span v-else>--</span>
                    </li>
                    <br />
                    <li :class="proposal.executorIBAN ? 'done' : 'required'">
                      <b>شماره شبا:</b> {{ proposal.executorIBAN }}
                    </li>
                    <li
                      :class="proposal.executorBankName ? 'done' : 'required'"
                    >
                      <b> نام بانک:</b> {{ proposal.executorBankName }}
                    </li>
                    <li
                      :class="
                        proposal.executorBankAccountName ? 'done' : 'required'
                      "
                    >
                      <b>نام صاحب حساب:</b>
                      {{ proposal.executorBankAccountName }}
                    </li>
                    <li :class="proposal.executorTel ? 'done' : 'required'">
                      <b>شماره تماس:</b> {{ proposal.executorTel }}
                    </li>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-3 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    مشخصات&nbsp;({{ step3progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 3"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul class="p-2">
                      <li
                        :class="proposal.enSubject ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>عنوان به زبان انگلیسی: </b> {{ proposal.enSubject }}
                      </li>
                      <li
                        :class="proposal.abstract ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>چکیده:</b> {{ proposal.abstract }}
                      </li>
                      <li
                        :class="proposal.keywords ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>کلید واژگان:</b> {{ proposal.keywords }}
                      </li>
                      <li
                        :class="proposal.doi ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>شناسه دیجیتال مجله:</b>
                        <span dir="ltr">{{ proposal.doi }}</span>
                      </li>
                      <li
                        :class="proposal.ISSN ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>ISSN مجله:</b>
                        <div v-if="proposal.ISSN">
                          <div
                            v-for="(item, index) in proposal.ISSN"
                            :key="index"
                            class="badge"
                          >
                            <h6 class="mb-0">
                              <b-badge
                                style="font-size: 13px !important"
                                pill
                                >{{ item }}</b-badge
                              >
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li
                        :class="proposal.impactFactor ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>ضریب تاثیر مجله:</b> {{ proposal.impactFactor }}
                      </li>
                      <li
                        :class="proposal.acknowledgment ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b>تشکرات:</b> {{ proposal.acknowledgment }}
                      </li>
                      <li
                        :class="proposal.articlePdfFile ? 'done' : 'required'"
                        class="my-2"
                      >
                        <b> فایل PDF مقاله: </b>
                        <a
                          v-if="proposal.articlePdfFile"
                          :href="proposal.articlePdfFile"
                          target="blank"
                          >{{ files[1].showName }}</a
                        >
                        <span v-else>--</span>
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-4 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    زمانبندی&nbsp;({{ step4progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 4"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-4"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul class="p-2">
                      <li
                        class="my-2"
                        :class="
                          proposal.articlePublicationDate ? 'done' : 'required'
                        "
                      >
                        <b> تاریخ چاپ (شمسی):</b>
                        {{ proposal.articlePublicationDate }}
                      </li>
                      <li
                        class="my-2"
                        :class="
                          proposal.articlePublicationDate ? 'done' : 'required'
                        "
                      >
                        <b>تاریخ چاپ (میلادی):</b>
                        {{
                          proposal.articlePublicationDate
                            ? moment(
                                proposal.articlePublicationDate,
                                "jYYYY/jMM/jDD"
                              ).format("YYYY/MM/DD")
                            : "-"
                        }}
                      </li>
                      <li
                        class="my-2"
                        :class="
                          proposal.articleSubmissionDate ? 'done' : 'required'
                        "
                      >
                        <b> تاریخ ثبت (شمسی):</b>
                        {{ proposal.articleSubmissionDate }}
                      </li>
                      <li
                        class="my-2"
                        :class="
                          proposal.articleSubmissionDate ? 'done' : 'required'
                        "
                      >
                        <b>تاریخ ثبت (میلادی):</b>
                        {{
                          proposal.articleSubmissionDate
                            ? moment(
                                proposal.articleSubmissionDate,
                                "jYYYY/jMM/jDD"
                              ).format("YYYY/MM/DD")
                            : "-"
                        }}
                      </li>
                      <li
                        class="my-2"
                        :class="
                          proposal.articleRevisionDate ? 'done' : 'required'
                        "
                      >
                        <b>تاریخ بازبینی (شمسی):</b>
                        {{ proposal.articleRevisionDate }}
                      </li>
                      <li
                        class="my-2"
                        :class="
                          proposal.articleRevisionDate ? 'done' : 'required'
                        "
                      >
                        <b>تاریخ بازبینی (میلادی):</b>
                        {{
                          proposal.articleRevisionDate
                            ? moment(
                                proposal.articleRevisionDate,
                                "jYYYY/jMM/jDD"
                              ).format("YYYY/MM/DD")
                            : "-"
                        }}
                      </li>
                      <li
                        class="my-2"
                        :class="
                          proposal.articleAcceptanceDate ? 'done' : 'required'
                        "
                      >
                        <b>تاریخ پذیرش (شمسی):</b>
                        {{ proposal.articleAcceptanceDate }}
                      </li>
                      <li
                        class="my-2"
                        :class="
                          proposal.articleAcceptanceDate ? 'done' : 'required'
                        "
                      >
                        <b> تاریخ پذیرش (میلادی):</b>
                        {{
                          proposal.articleAcceptanceDate
                            ? moment(
                                proposal.articleAcceptanceDate,
                                "jYYYY/jMM/jDD"
                              ).format("YYYY/MM/DD")
                            : "-"
                        }}
                      </li>
                      <li
                        class="my-2"
                        :class="
                          proposal.articleReleaseDate ? 'done' : 'required'
                        "
                      >
                        <b>تاریخ انتشار (شمسی):</b>
                        {{ proposal.articleReleaseDate }}
                      </li>
                      <li
                        class="my-2"
                        :class="
                          proposal.articleReleaseDate ? 'done' : 'required'
                        "
                      >
                        <b>تاریخ انتشار (میلادی):</b>
                        {{
                          proposal.articleReleaseDate
                            ? moment(
                                proposal.articleReleaseDate,
                                "jYYYY/jMM/jDD"
                              ).format("YYYY/MM/DD")
                            : "-"
                        }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-5 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    میزان وجه تشویقی&nbsp;({{ step5progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 5"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-5"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <b>مبلغ:</b>
                      <b-form-group>
                        <div
                          v-if="
                            0 < proposal.impactFactor &&
                            proposal.impactFactor < 4
                          "
                        >
                          <h3 class="text-success">
                            {{
                              (proposal.articleFinancialSupport =
                                "2,000,000 تومان")
                            }}
                          </h3>
                        </div>
                        <div
                          v-else-if="
                            4 <= proposal.impactFactor &&
                            proposal.impactFactor <= 8
                          "
                        >
                          <h3 class="text-success">
                            {{
                              (proposal.articleFinancialSupport =
                                "3,000,000 تومان")
                            }}
                          </h3>
                        </div>
                        <div v-else-if="proposal.impactFactor > 8">
                          <h3 class="text-success">
                            {{
                              (proposal.articleFinancialSupport =
                                "4,000,000 تومان")
                            }}
                          </h3>
                        </div>
                        <div v-else>
                          <h4 class="text-danger">
                            لطفا جهت تعیین میزان وجه تشویقی، از بخش مشخصات مقاله
                            ضریب تاثیر مجله را انتخاب کنید.
                          </h4>
                        </div>
                      </b-form-group>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-6 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    تعهدات&nbsp;({{ step6progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 6"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-6"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b-form-group disabled>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[0]"
                        >این مقاله در بخش حمایت از رساله های دکتری و یا در بخش
                        حمایت از پایان نامه های ارشد زیست فناوری مورد حمایت قرار
                        نگرفته است.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[1]"
                        >ملاک IF بر اساس JCR سال 2018 مورد تایید خواهد
                        بود.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[2]"
                        >ملاک میزان حمایت میزان دقیق IF خواهد
                        بود.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[3]"
                        >ثبت در خواست هیچگونه حقی برای پذیرش مقاله ایجاد نمی
                        کند.</b-form-checkbox
                      ></b-form-group
                    >
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-button
              :disabled="lastStepProgress != 100"
              class="m-2"
              variant="success"
              @click="submit()"
              >ارسال</b-button
            >
            <p v-if="lastStepProgress != 100" class="required">
              به منظور ارسال مقاله باید تمام مراحل را به صورت کامل (100%) پشت سر
              گذاشته باشید.
            </p>
          </b-tab>
        </b-tabs>
        <div class="d-flex justify-content-center mt-3">
          <!-- NOTE (b-previousPage-2) previous -->
          <b-button
            v-if="tabIndex != 0"
            class="mx-1"
            variant="light"
            @click="changePage('back')"
            >مرحله قبل</b-button
          >

          <!-- NOTE (b-saveDraft-2) previous -->
          <b-button
            :disabled="isSaving"
            class="mx-1"
            variant="success"
            @click="saveDraft()"
            >ثبت پیشنویس</b-button
          >

          <!-- NOTE (b-nextPage-2) previous -->
          <b-button
            v-if="tabIndex != 7"
            class="mx-1"
            variant="primary"
            @click="changePage('next')"
            >مرحله بعد</b-button
          >
        </div>
      </b-card>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time

export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
  },
  data() {
    return {
      reactivity: false,
      myTempFile0: false,
      myTempFile1: false,
      max: 100,
      infoo: "",

      moment: moment,
      selectedMehvar: 0,
      show: false,
      busy: false,
      writerCheckbox: false,
      encouragement: "",
      initial: {},
      date: "",
      source: "",
      doi: "",
      specs: {},
      colleaguesData: [],
      serviceItems: [],
      selectedColleague: "",
      executor: {},
      proposal: {},
      colleague: [],
      universities: [],
      otherUniversity: "",
      mehvars: [],
      zone: new Array(6).fill(false),
      otherMehvars: "",
      achievmentitems: [],
      tabIndex: 1,
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      writersItem: [],
      writersField: [
        { key: "index", label: "#" },
        { key: "nameEn", label: "نام و نام خانوادگی (انگلیسی)" },
        { key: "name", label: "نام و نام خانوادگی (فارسی)" },
        { key: "nationality", label: "ملیت" },
        { key: "position", label: "نقش نویسنده" },
      ],
      uploadedFiles: new Array(2).fill({
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      }),
      files: [
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
      ],
      promises: {},
      isSaving: false,
      isLoaded: true,
      showTop: false,
      pageLoaded: false,
    };
  },

  methods: {
    removeMehvar() {
      this.proposal.mehvarId = "";
      this.proposal.otherMehvars = "";
    },
    delFile(order, fileName) {
      this.uploadedFiles[order] = {
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      };
      this.files[order] = {
        showName: "",
        url: "",
        id: "",
      };
      this.proposal[fileName] = "";
      this.proposal[fileName + "Id"] = "";
    },
    onMounted() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.uploadedFiles = JSON.parse(JSON.stringify(this.uploadedFiles));
      this.files = JSON.parse(JSON.stringify(this.files));
      let acc = 0;

      // this.otherFiles = JSON.parse(JSON.stringify(this.otherFiles));

      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });

      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          // this.mehvars.push(
          //   new Object({
          //     id: 1,
          //     text: "سایر محورها",
          //     universityId: 1
          //   })
          // );
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
        })
        .catch((err) => {});

      /////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/article/getInfo",
          {
            requestId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal = res.data;
          this.files = res.data.uploadedFiles;
          this.colleagues = res.data.colleagues;

          //------------------------------
          this.errorMessage = this.proposal.adminMessage;

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
          setTimeout(() => {
            // NOTE (m-setTimeout) to set timeout for 200 ms
            this.show = true;
          }, 200);

          // this.additionalFiles = JSON.parse(res.data.project.files);

          this.fileBusy = false;
          this.pageLoaded = true;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
          setTimeout(() => {
            // NOTE (m-setTimeout) to set timeout for 200 ms
            this.show = true;
          }, 200);
        });
    },
    nameKeydown(e) {
      if (/[^a-zA-Z 0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    selectMehvar(index, mehvar) {
      // NOTE (m-selectMehvar) to specify the selected mehvar
      this.selectedMehvar = index;
      this.proposal.mehvarId = mehvar.id;
      this.$forceUpdate();
    },
    changePage(direction) {
      // NOTE (m-changePage) to go to the previous and next step in each step
      direction == "back" ? this.tabIndex-- : this.tabIndex++;

      // Scroll to Top
      window.scrollTo(0, 0);
      ////////////////

      // save draft !!!
      this.saveDraft();
      ////////////////
    },
    uploadFile(file, index, fileName) {
      // NOTE to upload files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.uploadedFiles[index].showProgress = true;
        this.uploadedFiles[index].variant = "info";
        this.uploadedFiles[index].uploadPercentage = 0;
        this.uploadedFiles[index].isUploaded = false;
        this.uploadedFiles[index].uploadButDisable = true;

        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/researcher/request/article/upload?requestId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.uploadedFiles[index].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.uploadedFiles[index].isUploaded = true;
              this.uploadedFiles[index].uploadPercentage = 100;
              this.uploadedFiles[index].striped = false;
              this.uploadedFiles[index].variant = "success";
              this.uploadedFiles[index].uploadButDisable = false;
              this.proposal[fileName] = d.data.url;
              this.proposal[fileName + "Id"] = d.data.id;
              this.files[index] = d.data;
              //this.files[index].title = this.fileTitles[index];
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.uploadedFiles[index].uploadPercentage = 0;
            this.uploadedFiles[index].isUploaded = false;
          });
      }
    },
    saveDraft() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.showTop = true;
      this.isSaving = true;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/article/draft",
          {
            requestId: this.$route.params.id,
            uploadedFiles: this.files,
            mehvarId: this.proposal.mehvarId,
            universityId: this.proposal.universityId,
            faSubject: this.proposal.faSubject,
            enSubject: this.proposal.enSubject,
            otherUniversity: this.proposal.otherUniversity,
            otherMehvars: this.proposal.otherMehvars,
            typeStudy: this.proposal.typeStudy,
            typeSystemicDevelopmental: this.proposal.typeSystemicDevelopmental,
            typePractical: this.proposal.typePractical,
            zoneMedicine: this.proposal.zoneMedicine,
            zoneAgriculture: this.proposal.zoneAgriculture,
            zoneEnvironment: this.proposal.zoneEnvironment,
            zoneIndustrial: this.proposal.zoneIndustrial,
            zoneBioComputing: this.proposal.zoneBioComputing,
            zoneOther: this.proposal.zoneOther,
            responsibleAuthor: this.proposal.responsibleAuthor,
            executorIBAN: this.proposal.executorIBAN,
            executorBankName: this.proposal.executorBankName,
            executorBankAccountName: this.proposal.executorBankAccountName,
            executorTel: this.proposal.executorTel,
            colleagues: this.colleagues,
            abstract: this.proposal.abstract,
            keywords: this.proposal.keywords,
            ISSN: this.proposal.ISSN,
            impactFactor: this.proposal.impactFactor,
            acknowledgment: this.proposal.acknowledgment,
            articleFinancialSupport: this.proposal.articleFinancialSupport,
            articlePublicationDate: this.proposal.articlePublicationDate,
            articleSubmissionDate: this.proposal.articleSubmissionDate,
            articleRevisionDate: this.proposal.articleRevisionDate,
            articleAcceptanceDate: this.proposal.articleAcceptanceDate,
            articleReleaseDate: this.proposal.articleReleaseDate,
            consentResponsibleAuthorFileId:
              this.proposal.consentResponsibleAuthorFileId,
            articlePdfFileId: this.proposal.articlePdfFileId,
            promiseArrays: this.proposal.promiseArrays,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          this.isSaving = false;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },
    submit() {
      this.isSaving = true;
      if (this.proposal.revision > 0) {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/article/edit",
            {
              requestId: this.$route.params.id,
              uploadedFiles: this.files,
              doi: this.proposal.doi,
              faSubject: this.proposal.faSubject,
              enSubject: this.proposal.enSubject,
              universityId: this.proposal.universityId,
              otherUniversity: this.proposal.otherUniversity,
              mehvarId: this.proposal.mehvarId,
              otherMehvars: this.proposal.otherMehvars,
              typeStudy: this.proposal.typeStudy,
              typeSystemicDevelopmental:
                this.proposal.typeSystemicDevelopmental,
              typePractical: this.proposal.typePractical,
              zoneMedicine: this.proposal.zoneMedicine,
              zoneAgriculture: this.proposal.zoneAgriculture,
              zoneEnvironment: this.proposal.zoneEnvironment,
              zoneIndustrial: this.proposal.zoneIndustrial,
              zoneBioComputing: this.proposal.zoneBioComputing,
              zoneOther: this.proposal.zoneOther,
              executorIBAN: this.proposal.executorIBAN,
              executorBankName: this.proposal.executorBankName,
              executorBankAccountName: this.proposal.executorBankAccountName,
              executorTel: this.proposal.executorTel,
              colleagues: this.colleagues,
              abstract: this.proposal.abstract,
              keywords: this.proposal.keywords,
              ISSN: this.proposal.ISSN,
              impactFactor: this.proposal.impactFactor,
              acknowledgment: this.proposal.acknowledgment,
              articleFinancialSupport: this.proposal.articleFinancialSupport,
              articlePublicationDate: this.proposal.articlePublicationDate,
              articleSubmissionDate: this.proposal.articleSubmissionDate,
              articleRevisionDate: this.proposal.articleRevisionDate,
              articleAcceptanceDate: this.proposal.articleAcceptanceDate,
              articleReleaseDate: this.proposal.articleReleaseDate,
              responsibleAuthor: this.proposal.responsibleAuthor,
              consentResponsibleAuthorFileId:
                this.proposal.consentResponsibleAuthorFileId,
              articlePdfFileId: this.proposal.articlePdfFileId,
              promiseArrays: this.proposal.promiseArrays,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res2) => {
            this.toast(res2.data, "success");
            this.isSaving = false;
            router.push("/researcher/article/" + this.$route.params.id);
          })
          .catch((err2) => {
            this.toast(err2.response.data, "error");
            this.isSaving = false;
          });
      } else {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/article/submit",
            {
              requestId: this.$route.params.id,
              uploadedFiles: this.files,
              doi: this.proposal.doi,
              faSubject: this.proposal.faSubject,
              enSubject: this.proposal.enSubject,
              universityId: this.proposal.universityId,
              otherUniversity: this.proposal.otherUniversity,
              mehvarId: this.proposal.mehvarId,
              otherMehvars: this.proposal.otherMehvars,
              typeStudy: this.proposal.typeStudy,
              typeSystemicDevelopmental:
                this.proposal.typeSystemicDevelopmental,
              typePractical: this.proposal.typePractical,
              zoneMedicine: this.proposal.zoneMedicine,
              zoneAgriculture: this.proposal.zoneAgriculture,
              zoneEnvironment: this.proposal.zoneEnvironment,
              zoneIndustrial: this.proposal.zoneIndustrial,
              zoneBioComputing: this.proposal.zoneBioComputing,
              zoneOther: this.proposal.zoneOther,
              executorIBAN: this.proposal.executorIBAN,
              executorBankName: this.proposal.executorBankName,
              executorBankAccountName: this.proposal.executorBankAccountName,
              executorTel: this.proposal.executorTel,
              colleagues: this.proposal.colleagues,
              abstract: this.proposal.abstract,
              keywords: this.proposal.keywords,
              ISSN: this.proposal.ISSN,
              impactFactor: this.proposal.impactFactor,
              acknowledgment: this.proposal.acknowledgment,
              articleFinancialSupport: this.proposal.articleFinancialSupport,
              articlePublicationDate: this.proposal.articlePublicationDate,
              articleSubmissionDate: this.proposal.articleSubmissionDate,
              articleRevisionDate: this.proposal.articleRevisionDate,
              articleAcceptanceDate: this.proposal.articleAcceptanceDate,
              articleReleaseDate: this.proposal.articleReleaseDate,
              responsibleAuthor: this.proposal.responsibleAuthor,
              consentResponsibleAuthorFileId:
                this.proposal.consentResponsibleAuthorFileId,
              articlePdfFileId: this.proposal.articlePdfFileId,
              promiseArrays: this.proposal.promiseArrays,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res2) => {
            this.toast(res2.data, "success");
            this.isSaving = false;
            router.push("/researcher/article/" + this.$route.params.id);
          })
          .catch((err2) => {
            this.toast(err2.response.data, "error");
            this.isSaving = false;
          });
      }
    },
  },

  computed: {
    step1progress() {
      let progress = 0;

      this.proposal.faSubject ? progress++ : 1;
      this.proposal.enSubject ? progress++ : 1;
      if (this.proposal.mehvarId && this.proposal.mehvarId != this.notMehvar) {
        progress++;
      } else {
        if (this.proposal.mehvarId == this.notMehvar) {
          if (this.proposal.otherMehvars) {
            progress++;
          }
        }
      }

      if (this.proposal.universityId != this.notUniversity) {
        progress++;
      } else {
        if (
          this.proposal.universityId == this.notUniversity &&
          this.proposal.otherUniversity
        ) {
          progress++;
        }
      }

      this.proposal.typeStudy ||
      this.proposal.typeSystemicDevelopmental ||
      this.proposal.typePractical
        ? progress++
        : 1;
      this.proposal.zoneMedicine ||
      this.proposal.zoneAgriculture ||
      this.proposal.zoneEnvironment ||
      this.proposal.zoneIndustrial ||
      this.proposal.zoneBioComputing ||
      this.proposal.zoneOther
        ? progress++
        : 1;
      progress = parseInt((progress / 6) * 100);
      return progress;
    },
    step2progress() {
      let progress = 0;
      let total = 0;

      if (this.colleagues.length > 0) {
        total = this.colleagues.length * 4;
        this.colleagues.forEach((x) => {
          x.nameEn ? progress++ : 1;
          x.name ? progress++ : 1;
          x.nationality ? progress++ : 1;
          x.position ? progress++ : 1;
        });
      } else {
        progress = 1;
        total = 1;
      }

      this.proposal.responsibleAuthor
        ? progress++
        : this.proposal.consentResponsibleAuthorFile
        ? progress++
        : 1;
      total++;
      this.proposal.executorIBAN ? progress++ : 1;
      total++;
      this.proposal.executorBankName ? progress++ : 1;
      total++;
      this.proposal.executorBankAccountName ? progress++ : 1;
      total++;
      this.proposal.executorTel ? progress++ : 1;
      total++;
      progress = parseInt((progress / total) * 100);
      return progress;
    },
    step3progress() {
      let progress = 0;

      this.proposal.enSubject ? progress++ : 1;
      this.proposal.abstract ? progress++ : 1;
      this.proposal.keywords ? progress++ : 1;
      this.proposal.doi ? progress++ : 1;
      this.proposal.ISSN ? progress++ : 1;
      this.proposal.impactFactor ? progress++ : 1;
      this.proposal.acknowledgment ? progress++ : 1;
      this.proposal.articlePdfFile ? progress++ : 1;

      progress = parseInt((progress / 8) * 100);
      return progress;
    },
    step4progress() {
      let progress = 0;

      this.proposal.articlePublicationDate ? progress++ : 1;
      this.proposal.articleSubmissionDate ? progress++ : 1;
      this.proposal.articleRevisionDate ? progress++ : 1;
      this.proposal.articleAcceptanceDate ? progress++ : 1;
      this.proposal.articleReleaseDate ? progress++ : 1;

      progress = parseInt((progress / 5) * 100);
      return progress;
    },
    step5progress() {
      let progress = 0;

      this.proposal.articleFinancialSupport ? progress++ : 1;

      progress = parseInt((progress / 1) * 100);
      return progress;
    },
    step6progress() {
      let progress = 0;
      for (let i = 0; i <= 4; i++) {
        this.proposal.promiseArrays[i] ? progress++ : 1;
      }
      return parseInt((progress / 4) * 100);
    },
    lastStepProgress() {
      let wholeSteps = 0;
      for (let i = 1; i <= 6; i++) {
        wholeSteps += this["step" + i + "progress"];
      }
      return parseInt(wholeSteps / 6);
    },
    computedMehvars() {
      // NOTE (c-computedMehvars) to after selecting university show to user list of mehvars of selected university
      let mehvarha = [];
      if (this.proposal.universityId) {
        mehvarha = this.mehvars.filter(
          (x) => x.universityId == this.proposal.universityId
        );
        if (this.proposal.universityId != this.notUniversity) {
          this.proposal.mehvarId = this.proposal.mehvarId;
        } else if (this.proposal.universityId == this.notUniversity) {
          this.proposal.mehvarId = this.notMehvar;
        }
      }

      if (this.proposal.universityId) {
        mehvarha.push(
          new Object({
            id: this.notMehvar,
            text: "سایر محورها",
            universityId: this.proposal.universityId,
          })
        );
      } else {
        mehvarha.push(
          new Object({
            id: 0,
            text: "لطفا ابتدا یک دانشگاه انتخاب کنید",
            universityId: this.proposal.universityId,
          })
        );
      }
      if (this.proposal.mehvarId)
        this.selectedMehvar = mehvarha.findIndex(
          (x) => x.id == this.proposal.mehvarId
        );
      else this.selectedMehvar = "-";
      // alert(mehvarha.map(y=>y.id))
      // this.proposal.mehvarId ? this.selectedMehvar = mehvarha.map(y=>y.id).findIndexOf(this.proposal.mehvarId) : this.selectedMehvar = ''
      return mehvarha;
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.onMounted();
  },
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
.b-form-tag-content {
  font-size: 13px !important;
}
</style>
